import {
  LabelFeature as labelReducer,
  LabelPayload,
  setLabelAction,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../../Types';
import { dummyDispatch } from '../ParamFromSchema';

export const reduceLabel =
  (payload: LabelPayload) => (state: BridgeFormJSState) =>
    labelReducer(state, setLabelAction(dummyDispatch)(payload));
